/* eslint-disable */
//tslint:disable
export var EDealType;

(function (EDealType) {
  EDealType["Rent"] = "rent";
  EDealType["Sale"] = "sale";
})(EDealType || (EDealType = {}));

export var EOfferType;

(function (EOfferType) {
  EOfferType["Commercial"] = "commercial";
  EOfferType["Flat"] = "flat";
  EOfferType["Newobject"] = "newobject";
  EOfferType["Suburban"] = "suburban";
})(EOfferType || (EOfferType = {}));